import { useGetAgendaRecordQuery, useGetAgendaRecordsCreateQuery } from 'store/services/flow/agendaRecords';
import { useMemo } from 'react';
import type { RecordFormItem } from 'types';

export const useAgendaRecordData = (agendaId: string, isNew: boolean, recordId: string = '') => {
  const { data: createData, isFetching: isCreating } = useGetAgendaRecordsCreateQuery({ agendaId }, { skip: !isNew });
  const { data: recordData, isFetching: isRecordFetching } = useGetAgendaRecordQuery({ agendaId, recordId }, { skip: isNew || !recordId });

  const { tabs, items } = useMemo(() => {
    const processedTabs = isNew ? (createData?.tabs ?? []) : (recordData?.tabs ?? []);

    const processedItems =
      processedTabs.length === 0
        ? []
        : processedTabs.reduce<RecordFormItem[]>((acc, tab) => {
            const sectionItems = tab.sections.reduce<RecordFormItem[]>((sectionAcc, section) => {
              return sectionAcc.concat(section.formItems);
            }, []);
            return acc.concat(sectionItems);
          }, []);

    return { tabs: processedTabs, items: processedItems };
  }, [isNew, createData?.tabs, recordData?.tabs]);

  const isFetching = isCreating || isRecordFetching;
  const record = recordData?.record;

  return {
    tabs,
    record,
    items,
    isFetching,
  };
};
